<div class="price-info" [ngClass]="{'flex-column price-info-grid' : isSidePanel && !isFlexedCol}">
    <div class="price-info_row">
      <div class="price-info_box">
        <div class="price-info_box--title">Breakeven price</div>
        <div class="price-info_box--detail">
          <div class="price-container">
            <div>
              <div class="price-container_header">
                <span>Costs</span>
                <span>{{(feeDetail?.cost || 0) | currency}}</span>
              </div>
              <div class="price-container_body">
                <div class="d-flex align-items-center justify-content-between">
                  <span>COGS</span>
                  <span>{{(feeDetail?.cogs || 0) | currency}}</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <span>Prep cost</span>
                  <span>{{(feeDetail?.prepCost || 0) | currency}}</span>
                </div>
              </div>
            </div>
            <div>
              <div class="price-container_header">
                <span>Fees</span>
                <span>{{(feeDetail?.fee ||0 ) | currency}}</span>
              </div>
              <div class="price-container_body">
                <div class="d-flex align-items-center justify-content-between">
                  <span>FBA fee</span>
                  <span>{{(feeDetail?.fbaFees || 0) | currency}}</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <span>Referal fee ({{ (((feeDetail?.referalFees / feeDetail?.breakevenTotal) * 100) || 0) | number}}%)</span>
                  <span>{{(feeDetail?.referalFees  || 0) | currency}}</span>
                </div>
              </div>
            </div>
            <div>
              <div class="price-container_header">
                <span>Profit</span>
                <span>{{(feeDetail?.profitForBreakEvenPrice || 0) | currency}}</span>
              </div>
              <div class="price-container_body">
                <div class="d-flex align-items-center justify-content-between">
                  <span>Markup (0%)</span>
                  <span>{{feeDetail?.markupForBreakEvenPrice || 0}}%</span>
                </div>
              </div>
            </div>
            <div class="price-container_footer">
              Total: {{(feeDetail?.breakevenTotal || 0) | currency}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="price-info_row">
      <div class="price-info_box">
        <div class="price-info_box--title">Minimum price <span *ngIf="feeDetail && !feeDetail?.IsMinPriceManuallySet" class="title-badge">Auto</span></div>
        <div class="price-info_box--detail">
          <div class="price-container">
            <div>
              <div class="price-container_header">
                <span>Costs</span>
                <span>{{(feeDetail?.cost || 0) | currency}}</span>
              </div>
              <div class="price-container_body">
                <div class="d-flex align-items-center justify-content-between">
                  <span>COGS</span>
                  <span>{{(feeDetail?.cogs || 0 )| currency}}</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <span>Prep cost</span>
                  <span>{{(feeDetail?.prepCost || 0) | currency}}</span>
                </div>
              </div>
            </div>
            <div>
              <div class="price-container_header">
                <span>Fees</span>
                <span>{{(feeDetail?.fee || 0) | currency}}</span>
              </div>
              <div class="price-container_body">
                <div class="d-flex align-items-center justify-content-between">
                  <span>FBA fee</span>
                  <span>{{(feeDetail?.fbaFees || 0) | currency}}</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <span>Referal fee ({{ (((feeDetail?.referalFees / feeDetail?.minPriceTotal) * 100) || 0) | number}}%)</span>
                  <span>{{(feeDetail?.referalFees || 0) | currency}}</span>
                </div>
              </div>
            </div>
            <div>
              <div class="price-container_header">
                <span>Profit</span>
                <span>{{(feeDetail?.profitForMinPrice || 0) | currency}}</span>
              </div>
              <div class="price-container_body">
                <div class="d-flex align-items-center justify-content-between">
                  <span>Markup (0%)</span>
                  <span>{{(feeDetail?.markupForMinPrice || 0 )|| 0}}%</span>
                </div>
              </div>
            </div>
            <div class="price-container_footer">
              Total: {{(feeDetail?.minPriceTotal || 0) | currency}}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="price-info_row">
      <div class="price-info_box">
        <div class="price-info_box--title">Maximum price <span *ngIf="feeDetail && !feeDetail?.IsMaxPriceManuallySet" class="title-badge">Auto</span></div>
        <div class="price-info_box--detail">
          <div class="price-container">
            <div>
              <div class="price-container_header">
                <span>Costs</span>
                <span>{{(feeDetail?.cost || 0) | currency}}</span>
              </div>
              <div class="price-container_body">
                <div class="d-flex align-items-center justify-content-between">
                  <span>COGS</span>
                  <span>{{(feeDetail?.cogs || 0) | currency}}</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <span>Prep cost</span>
                  <span>{{(feeDetail?.prepCost || 0 )| currency}}</span>
                </div>
              </div>
            </div>
            <div>
              <div class="price-container_header">
                <span>Fees</span>
                <span>{{(feeDetail?.fee || 0) | currency}}</span>
              </div>
              <div class="price-container_body">
                <div class="d-flex align-items-center justify-content-between">
                  <span>FBA fee</span>
                  <span>{{(feeDetail?.fbaFees || 0) | currency}}</span>
                </div>
                <div class="d-flex align-items-center justify-content-between">
                  <span>Referal fee ({{ (((feeDetail?.referalFees / feeDetail?.maxPriceTotal) * 100) || 0) | number}}%)</span>
                  <span>{{(feeDetail?.referalFees || 0) | currency}}</span>
                </div>
              </div>
            </div>
            <div>
              <div class="price-container_header">
                <span>Profit</span>
                <span>{{(feeDetail?.profitForMaxPrice || 0) | currency}}</span>
              </div>
              <div class="price-container_body">
                <div class="d-flex align-items-center justify-content-between">
                  <span>Markup (0%)</span>
                  <span>{{feeDetail?.markupForMaxPrice || 0}}%</span>
                </div>
              </div>
            </div>
            <div class="price-container_footer">
              Total: {{(feeDetail?.maxPriceTotal || 0) | currency}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>